/*

DEFINE A URL BASE DA API DE BACKEND E STRING DE IDENTIFICAÇÃO DE AMBIENTE

**Para ambientes locais (Desenvolvimento)**
- Ter um arquivo .env com as variáveis de ambiente "carregadas" [1], ex.:

REACT_APP_API_URL_INTRACRED="https://app-intracred-core-api-development.azurewebsites.net"
REACT_APP_ENVIRONMENT="Desenvolvimento (Local)"

**Para ambientes remotos (Teste Integrado, Homologação e Produção)**
- Os valores são recuperados de variáveis de ambiente as quais são "carregadas" em tempo de build do NodeJS [2]
- A definição os valores dessas variáveis de ambiente estão nos respectivos arquivos YAML de workflow
 do GitHub Actions, localizados em /.github/workflows/
- O "carregamento" por variáveis de ambiente dentro do Azure Static Web App não é aplicável [3]

**Referências**
[1] https://microsoft.github.io/MicrosoftCloud/tutorials/docs/ACS-to-Teams-Meeting/Deploy-to-SWA/
[2] https://stackoverflow.com/questions/67642978/create-react-app-hosted-as-static-app-on-azure-doesnt-detect-env-vars
[3] https://dev.to/aadilraza339/what-is-env-file-in-node-js-3h6c

*/

 export const baseURL = process.env['REACT_APP_API_URL_INTRACRED'];
 export const ambiente = process.env['REACT_APP_ENVIRONMENT'];